import firebase from "firebase";
import {
    SERVICES_FIELD_CHANGED,
    FETCH_SERVICES,
    FETCH_SERVICES_FAILED,
    FETCH_SERVICES_SUCCESSFUL,
    FETCH_MORE_SERVICES,
    FETCH_MORE_SERVICES_FAILED,
    FETCH_MORE_SERVICES_SUCCESSFUL,
    PUSH_SERVICE_REQUEST,
    SHOW_NEW_ACTIVITY_MODAL,
    DELETE_SERVICE_REQUEST,
    DELETE_SERVICE_REQUEST_SUCCESSFUL,
    DELETE_SERVICE_REQUEST_FAILED,
    RESOLVE_SERVICE_REQUEST,
    RESOLVE_SERVICE_REQUEST_SUCCESSFUL,
    RESOLVE_SERVICE_REQUEST_FAILED,
    FETCH_LEGAL_SERVICES_SUCCESSFUL,
} from "./Types";
import {getAdmins} from "./AppActions";

//property declarations
const retrievedProject = localStorage.getItem('lalertInitializedProject');
let project = {};
if (retrievedProject) {
    project = JSON.parse(retrievedProject);
}

export const serviceFieldChanged = ({ prop, value }) => {
    return {
        type: SERVICES_FIELD_CHANGED,
        payload: { prop, value }
    }
};

//------------------------------------------------------ ALL ACTIVITIES -----------------------------------------------------------//

export const fetchServices = ({ startAt }) => {
    return(dispatch) => {
        dispatch({ type: FETCH_SERVICES });
        firebase.firestore().collection("serviceRequests")
            .orderBy("serviceRequestDate", "desc").limit(startAt)
            .onSnapshot((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_SERVICES_FAILED });
                } else {
                    let services = [];
                    snapshot.forEach(doc => {
                        const service = doc.data();
                        services.push(service);
                    });

                    dispatch({
                        type: FETCH_SERVICES_SUCCESSFUL,
                        payload: { services, startAt }
                    });
                }
            }, function (e) {
                dispatch({ type: FETCH_SERVICES_FAILED });
                console.log(e);
            })
    };
};

export const fetchMoreServices = ({ startAt }) => {
    return(dispatch) => {
        dispatch({ type: FETCH_MORE_SERVICES });
        firebase.firestore().collection("serviceRequests")
            .orderBy("serviceRequestDate", "desc").limit(startAt)
            .onSnapshot((snapshot) => {
                if (snapshot.size === 0) {
                    //there is no data
                    dispatch({ type: FETCH_MORE_SERVICES_FAILED });
                } else {
                    let services = [];
                    snapshot.forEach(doc => {
                        const service = doc.data();
                        services.push(service);
                    });

                    dispatch({
                        type: FETCH_MORE_SERVICES_SUCCESSFUL,
                        payload: { services, startAt }
                    });
                }
            }, function (e) {
                dispatch({ type: FETCH_MORE_SERVICES_FAILED });
                console.log(e);
            })
    };
};

//------------------------------------------------------ SAVE ACTIVITIES -----------------------------------------------------------//

export const showNewActivityModal = () => {
    return {
        type: SHOW_NEW_ACTIVITY_MODAL
    }
}

// export const hideNewActivityModal = () => {
//     return {
//         type: HIDE_NEW_ACTIVITY_MODAL
//     }
// }

export const fetchLegalServices = () => {
    return(dispatch) => {
        firebase.firestore().collection("legalServices")
            .onSnapshot(snapshot => {
                if (snapshot.size !== 0) {
                    let legalServices = [];
                    snapshot.forEach(doc => {
                        const data = doc.data();
                        legalServices.push(data);
                    });

                    dispatch({
                        type: FETCH_LEGAL_SERVICES_SUCCESSFUL,
                        payload: legalServices
                    })
                }
            })
    };
};

//-------------------------------------------------------------------------------------------------------------

export const pushServiceRequest = (activity) => {
    return {
        type: PUSH_SERVICE_REQUEST,
        payload: activity
    }
}


export const deleteEnquiry = ({ service }) => {
    return(dispatch) => {
        dispatch({
            type: DELETE_SERVICE_REQUEST
        });

        const url = `${project.serverUrl}deleteEnquiry`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ userID: service.userID, serviceRequestID: service.serviceRequestID }),
            mode: 'cors',
            headers: {'Content-Type': 'application/json'},
        }).then((response) => response.json())
            .then((response) => {
                console.log(response);
                dispatch({
                    type: DELETE_SERVICE_REQUEST_SUCCESSFUL
                });
                getAdmins({ dispatch });
            }).catch((error) => {
            console.log(error);
            dispatch({
                type: DELETE_SERVICE_REQUEST_FAILED
            });
        });
    }
};

export const resolveEnquiry = ({ service }) => {
    return(dispatch) => {
        dispatch({
            type: RESOLVE_SERVICE_REQUEST
        });

        const url = `${project.serverUrl}resolveEnquiry`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ userID: service.userID, serviceRequestID: service.serviceRequestID }),
            mode: 'cors',
            headers: {'Content-Type': 'application/json'},
        }).then((response) => response.json())
            .then((response) => {
                console.log(response);
                dispatch({
                    type: RESOLVE_SERVICE_REQUEST_SUCCESSFUL
                });
                getAdmins({ dispatch });
            }).catch((error) => {
            console.log(error);
            dispatch({
                type: RESOLVE_SERVICE_REQUEST_FAILED
            });
        })
    }
};